export const InvoiceSettingsCreatorGridPluginSettings: IPluginSettings = {
    name: 'Настройка импорта',
    mnemocode: 'invoice_settings_creator',
    permission: 'InvoiceImportMappingModel',
    columns: [],
}
